import script from "./JoinUsmy.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinUsmy.vue?vue&type=script&setup=true&lang=js"

import "./JoinUsmy.vue?vue&type=style&index=0&id=5bdde174&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bdde174"]])

export default __exports__